import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import store from './store.js'

import Bookingbar from './Bookingbar.vue'
import Bookingform from './Bookingform.vue'
import Bookingwidget from './Bookingwidget.vue'
import Subscriptionwidget from './Subscriptionwidget.vue'
import Currencypopupsub from './Currencypopupsub.vue'

Vue.config.productionTip = false

import SlideUpDown from 'vue-slide-up-down'
Vue.component('slide-up-down', SlideUpDown)

import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
// set default config -> session
Vue.$cookies.config('')

// use portal for sticky part of widget
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

const wmxComponent = {
	created: function () {
		//
	},
	methods: {
		sanitizeString: function(str){
			if(!str || str == '') return str;
			const umlautMap = {
				'\u00dc': 'UE',
				'\u00c4': 'AE',
				'\u00d6': 'OE',
				'\u00fc': 'ue',
				'\u00e4': 'ae',
				'\u00f6': 'oe',
				'\u00df': 'ss',
			}
			str = str.replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
				const big = umlautMap[a.slice(0, 1)];
				return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
			})
				.replace(new RegExp('['+Object.keys(umlautMap).join('|')+']',"g"),
					(a) => umlautMap[a]
				)
			str = str.replace(/\s,-]/gim, "_")
			str = str.replace(/[^a-z0-9áéíóúñü]/gim, "")
			return str.trim();
		},
		clearTags: function(str) {
			return str.replace(/(<([^>]+)>)/gi, "")
		}
	}
}


if(document.getElementById('vue-bookingwidget')) {

	new Vue({
		render: h => h(Bookingwidget),
		mixins: [wmxComponent],
		store,
	}).$mount('#vue-bookingwidget')
}
if(document.getElementById('vue-subscriptionwidget')) {
	new Vue({
		render: h => h(Subscriptionwidget),
		mixins: [wmxComponent],
		store,
	}).$mount('#vue-subscriptionwidget')
}
if(document.getElementById('vue-currencypopupsub')) {
	new Vue({
		render: h => h(Currencypopupsub),
		mixins: [wmxComponent],
		store,
	}).$mount('#vue-currencypopupsub')
}
if(document.getElementById('vue_bookingbar')) {
	new Vue({
		render: h => h(Bookingbar),
		mixins: [wmxComponent],
		store,
	}).$mount('#vue_bookingbar')
}
if(document.getElementById('vue_bookingform')) {
	new Vue({
		render: h => h(Bookingform),
		mixins: [wmxComponent],
		store,
	}).$mount('#vue_bookingform')
}